import './App.css';
import AgentPanel from './components/AgentPanel';

function App() {
  return <AgentPanel />;
}

export default App;
